<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start" :key="updateData">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100">
                  <contentList
                  @submitData="submitData"
                  :page="page"
                  :form-data="formData"
                  :gender-data="genderData"
                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent :page="page" :table-data="tableData" @deleteItemTable="deleteItemTable" :all-enums="allEnums" ></tableContent>
      </Loader>
  </div>
</template>

<script>
import contentList from '../components/teamPlayer/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/teamPlayer/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';



export default {
  name: "teamPlayer",
  components: {
    contentList,
    appHeader,
    tableContent,
  },

  props: {

  },

  data() {
    return {
      loading                                 : true,
      updateCitySelected                      : 0,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData   : {
        family          : '',
        name            : '',
        slogan          : '',
        birth_date      : '',
        mobile          : '',
        national_code   : '',
        // full_name       : '',
        gender          : '',
        image           : '',
        nameSalon       : '',

        id              : -1,
        cup_id          : '',
        player_id       : '',

        include_owner   : 1,
        include_players : 1,
        include_cup     : 1,
        per_page        : 10,
        page            :  1,
      },
      tableData                               : [],
      page                                    : 1,
      statusRunPaganation                     : true,
      resetPagePaganation                     : 0,
      allEnums                                : [],
      updateData                              : 0,
      lastUpdateJsonLocalStorageSinglePlayer  : {},
      genderData                              : [
        {
          id    : 'male',
          title : 'مرد'
        },
        {
          id    : 'female',
          title : 'زن'
        },
        {
          id    : 'unset',
          title : 'هر دو'
        },

      ],


    }
  },

  watch: {
    tableData(){
      this.updateData++;
      this.loading = false;
    },

    // allEnums(data){
    //   for (let key in data.gender) {
    //     const newGender = {
    //       title : '',
    //       id    : key,
    //     };
    //     const valueGender = data.gender[key];
    //     newGender.title   = valueGender;
    //     this.genderData   = [...this.genderData,newGender]
    //   }
    // }

  },

  created() {

  },


  mounted() {
    const getPlayerId = this.$route.params.id;
    if (typeof(getPlayerId) != 'undefined') {
      this.formData.id = getPlayerId;
    }
    else {
      delete this.formData.id;
    }

    this.getEnum();
  },


  methods: {
    getTableData(){

      // this.$store
      // .dispatch('teams/getTableDataPlayer', {
      //   data : {
      //     ...this.formData,
      //   }
      // })
      // .then((res)=>{
      //   this.loading     = false;
      //   this.convertTimeStampInToJalali(res.data);
      //   this.tableData   = res.data;
      // })

      const getSingleDataTeam = JSON.parse(localStorage.getItem('singleDataTeam'));
      this.tableData          = getSingleDataTeam.players;
      this.convertTimeStampInToJalali(this.tableData);
    },

    submitData(data){
      this.formData     = data;
      this.loading      = true;


      this.$store
      .dispatch('teams/addPlayer', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading      = false;
        if (!res.is_successful) {
          this.$message.error(res.message);
        }

      })
    },

    convertTimeStampInToJalali(tableData){
      tableData.map((t,i)=>{
        const resultConvert    = this.$moment(t.birth_date).format("jYYYY-jMM-jDD");
        t.birthDateJlali       = resultConvert;
      })
    },

    getEnum(data){
      this.$store
      .dispatch('listCups/getEnum', {
      })
      .then((res)=>{
        this.allEnums = res.data;
        this.getTableData();
      })
    },

    deleteItemTable(data){
      this.loading      = true;

      const getSingleDataTeam        = JSON.parse(localStorage.getItem('singleDataTeam'));
      let allPlayerResultAfterDelete = [];


      getSingleDataTeam.players.map((t)=>{
        if (t.id != data.id) {
          allPlayerResultAfterDelete = [...allPlayerResultAfterDelete,t];
        }
      })

      getSingleDataTeam.players       = allPlayerResultAfterDelete;


      this.$store
      .dispatch('listCups/deletePlayer', {
        data : {
          id        : data.pivot.team_id,
          player_id : data.pivot.player_id,
        }
      })
      .then((res)=>{
        this.loading      = false;
        if (res.is_successful) {
          getSingleDataTeam.players       =  allPlayerResultAfterDelete;
          const lastUpdateSinglePlayer    = localStorage.setItem('singleDataTeam', JSON.stringify(getSingleDataTeam));
          const lastUpdateSingleDataTeam  = JSON.parse(localStorage.getItem('singleDataTeam'));
          this.tableData                  = lastUpdateSingleDataTeam.players;
          this.convertTimeStampInToJalali(this.tableData);
        }
        else {
          this.$message.error(res.message);
        }
      })

    }








  }


}
</script>
